export const uk_labels = {
    file_input_button_label: 'Вибрати файл',
    save_success: 'Дані були успішно збережені',
    remove_success: 'Інформацію успішно видалено',
    remove_error: 'Інформацію не вдалося видалити',
    remove_confirm_text: 'Ви бажаєте видалити інформацію?',
    save_error: 'Дані не вдалося зберегти. Перевірте чи заповнено усі необхідні поля.',

    //Main navigation 
    nav_home: "Головнa",
    nav_settings: "Налаштування",

    //Menu items settings
    settings_lng: "Мови",
    settings_srvc: "Сервіси",
    settings_abt: "Про нас",

    //No mach page  
    go_home_btn: "На головну",
    not_found_msg: "Сторінку не знайдено...",

    // Auth labels
    login_label: "Логін",
    pass_label: "Пароль",
    sign_in_title: "Увійти",
    submit_btn: "Надіслати",
    loading_btn: "Завантаження...",
    login_placeholder: "введіть логін",
    pass_placeholder: "введіть пароль",
    error_msg_input_validate: "Поле обов'язкове",
    error_msg_admin_login: "У вас немає права доступу",

    //sidebar labels
    logout_btn: "Вийти",
    confirm_btn_no: "Ні",
    confirm_btn_yes: "Так",
    confirm_msg: "Ви дійсно хочете вийти?",

    //LanguagePage labels
    thead_number: "Id",
    thead_action: "Дія",
    thead_name: "Назва",
    is_default_no: "Ні",
    thead_flag: "Прапор",
    thead_ico: "Ісо код",
    is_default_yes: "Так",
    add_form_name: "Назва",
    add_form_flag: "Прапор",
    checkbox_default: "Так",
    add_form_ico: "Ico код",
    btn_save_lng: "Зберегти",
    lng_btn_close: "Закрити",
    lng_btn_update: "Оновити",
    checkbox_active: "Активна",
    btn_edit_lng: "Редагувати",
    btn_delete_lng: "Видалити",
    delete_confirm_btn_no: "Ні",
    lng_page_title: "Список мов",
    btn_add_lng: "Добавити мову",
    delete_confirm_btn_yes: "Так",
    add_active_lng: "Активна мова",
    lng_add_success: "Мова додана",
    update_modal_title: "Оновити дані",
    lng_update_success: "Мову оновлено",
    lng_delete_success: "Мову видалено",
    add_defoult_lng: "Мова за замовчуванням",
    delete_confirm_msg: "Дозволити видалити ?",
    thead_is_default: "За замовчуванням (так/ні)",
    lng_required_field: "Поля вводу обов'язкові",

    //settigs page labels
    btn_cancel: "Вийти",
    table_title: "Список мов",
    btn_updated_lng: "Зберегти",
    btn_send_add_lng: "Надіслати",
    lng_form_title: "Заповніть поля",
    add_form_placeholder: "Введіть дані в поле",
    settings_page_title: "Загальні налаштування",

    //about page
    about_us_information: "Про нас",
    about_items_category: "Категорії",
    about_items_orders: "Записи",

    //vacancies page
    vacancies: "Вакансії",
    vacancies_items_category: "Категорії",
    vacancies_items_orders: "Записи",

    //transportation to order page
    transportation_to_order: "Послуги",
    transportation_to_order_category: "Категорії",
    transportation_to_order_orders: "Записи",

    //driving school page
    ds_categories: "Категорії",
    ds_records: "Записи",
    ds_add_form_type: "Категорія",
    ds_add_form_empty_type: "Виберіть категорію",
    ds_id_table: "Iд",
    ds_active_no: "Ні",
    ds_active_yes: "Так",
    ds_action_table: "Дія",
    ds_title_table: "Назва",
    ds_category_table: "Категорія",
    ds_content_table: "Вміст",
    ds_add_form_title: "Hазва",
    ds_add_form_content: "Опис",
    ds_add_form_position: "Позиція",
    ds_nav_title: "Школа водіїв",
    ds_nav_category_title: "Категорії",
    ds_nav_records_title: "Записи",
    ds_active_table: "Відображається",
    ds_position_table: "Позиція",
    ds_btn_select_file: "Вибрати файл",
    ds_edit_button_title: "Редагувати",
    ds_delete_button_title: "Видалити",
    ds_add_active: "Відображати на сайті",
    ds_btn_add_news: "Добавити оголошення",
    ds_upload_file_title: "Завантажте файл:",
    ds_title: "Школа водіїв | cписок оголошень",
    ds_btn_update_news: "Зберегти внесені зміни",
    ds_list_empty: "Немає даних для відображення",
    ds_add_new_popup_title: "Додати нове оголошення",
    ds_edit_popup_title: "Внесення змін в оголошення",
    ds_img_empty_title: "Зображення (при необхідності)",

    //road to aeroports
    rta_nav_title: "Дорога до аеропорту",

    //information for tourists
    ift_nav_title: "Інформація для туристів",

    //international projects
    ip_nav_title: "Міжнародні проекти",

    //electricity supply
    es_nav_title: "Постачання електроенергії",

    //news
    news_nav_title: "Новини",
    //news categories
    nc_id_table: "Iд",
    nc_active_no: "Ні",
    nc_active_yes: "Так",
    nc_action_table: "Дія",
    nc_title_table: "Назва",
    nc_content_table: "Вміст",
    nc_add_form_title: "Hазва",
    nc_add_form_content: "Опис",
    nc_title: "Новини | Категорії",
    nc_active_table: "Відображається",
    nc_btn_select_file: "Вибрати файл",
    nc_edit_button_title: "Редагувати",
    nc_delete_button_title: "Видалити",
    nc_add_active: "Відображати на сайті",
    nc_upload_file_title: "Завантажте файл:",
    nc_btn_add_news: "Добавити нову категорію",
    nc_btn_update_news: "Зберегти внесені зміни",
    nc_list_empty: "Немає даних для відображення",
    nc_edit_popup_title: "Внесення змін в новину",
    nc_add_new_popup_title: "Додати нову категорію",
    nc_img_empty_title: "Зображення (при необхідності)",
    //news records
    nr_id_table: "Iд",
    nr_active_no: "Ні",
    nr_active_yes: "Так",
    nr_action_table: "Дія",
    nr_title_table: "Назва",
    nr_content_table: "Вміст",
    nr_add_form_title: "Hазва",
    nr_add_form_publication_date: "Дата новини",
    nr_add_form_content: "Опис",
    nr_title: "Новини | Статті",
    nr_nav_title: "Школа водіїв",
    nr_active_table: "Відображається",
    nr_btn_select_file: "Вибрати файл",
    nr_edit_button_title: "Редагувати",
    nr_delete_button_title: "Видалити",
    nr_add_active: "Відображати на сайті",
    nr_btn_add_news: "Добавити нову статтю",
    nr_form_type_id_input_label: "Категорія",
    nr_upload_file_title: "Завантажте файл:",
    nr_btn_update_news: "Зберегти внесені зміни",
    nr_list_empty: "Немає даних для відображення",
    nr_add_new_popup_title: "Додати нову статтю",
    nr_edit_popup_title: "Внесення змін в оголошення",
    nr_img_empty_title: "Зображення (при необхідності)",
    nr_form_type_id_input_empty_row: "Виберіть категорію",

    //road situation
    rs_nav_title: "Ситуація на дорозі",

    //subscribers
    s_id_table: "Iд",
    s_active_no: "Ні",
    s_active_yes: "Так",
    s_name_table: "Ім'я",
    s_action_table: "Дія",
    s_email_table: "Емейл",
    s_nav_title: "Розсилка",
    s_add_form_name: "Ім'я",
    s_add_form_email: "Емейл",
    s_title: "Список підписників",
    s_active_table: "Відображається",
    s_btn_select_file: "Вибрати файл",
    s_edit_button_title: "Редагувати",
    s_delete_button_title: "Видалити",
    s_add_active: "Відображати на сайті",
    s_btn_add: "Добавити нового підписника",
    s_btn_update: "Зберегти внесені зміни",
    s_list_empty: "Немає даних для відображення",
    s_add_new_popup_title: "Додати нового підписника",
    s_edit_popup_title: "Внесення змін про підписника",

    //Users
    u_th_id: "Iд",
    u_active_no: "Ні",
    u_active_yes: "Так",
    u_th_info: "Деталі",
    flip_beck_id: "Iд :",
    u_action_table: "Дія",
    u_th_first_name: "Ім'я",
    u_btn_info: "Інформація",
    flip_beck_name: "Ім'я :",
    u_empty_middle_name: " ",
    nav_users: "Користувачі",
    u_th_second_name: "Прізвище",
    u_th_last_name: "По-батькові",
    u_title: "Список користувачів",
    u_btn_update: "Зберегти зміни",
    u_title_active: "Активний",
    flip_beck_second_name: "Прізвище :",
    flip_beck_last_name: "По-батькові :",
    flip_beck_active: "Активувати користувача",
    u_list_empty: "Немає даних для відображення",
    flip_beck_admin: "Надати права адміністратора",

    // tickets
    nav_ticket: "Квитки",

}